export var ShapeEnum;
(function (ShapeEnum) {
    ShapeEnum[ShapeEnum["diamond"] = 0] = "diamond";
    ShapeEnum[ShapeEnum["ellipse"] = 1] = "ellipse";
    ShapeEnum[ShapeEnum["box"] = 2] = "box";
    ShapeEnum[ShapeEnum["circle"] = 3] = "circle";
    ShapeEnum[ShapeEnum["record"] = 4] = "record";
    ShapeEnum[ShapeEnum["plaintext"] = 5] = "plaintext";
    ShapeEnum[ShapeEnum["point"] = 6] = "point";
    ShapeEnum[ShapeEnum["mdiamond"] = 7] = "mdiamond";
    ShapeEnum[ShapeEnum["msquare"] = 8] = "msquare";
    ShapeEnum[ShapeEnum["polygon"] = 9] = "polygon";
    ShapeEnum[ShapeEnum["doublecircle"] = 10] = "doublecircle";
    ShapeEnum[ShapeEnum["house"] = 11] = "house";
    ShapeEnum[ShapeEnum["invhouse"] = 12] = "invhouse";
    ShapeEnum[ShapeEnum["parallelogram"] = 13] = "parallelogram";
    ShapeEnum[ShapeEnum["octagon"] = 14] = "octagon";
    ShapeEnum[ShapeEnum["tripleoctagon"] = 15] = "tripleoctagon";
    ShapeEnum[ShapeEnum["triangle"] = 16] = "triangle";
    ShapeEnum[ShapeEnum["trapezium"] = 17] = "trapezium";
    ShapeEnum[ShapeEnum["drawFromGeometry"] = 18] = "drawFromGeometry";
    ShapeEnum[ShapeEnum["hexagon"] = 19] = "hexagon";
})(ShapeEnum || (ShapeEnum = {}));
//# sourceMappingURL=shapeEnum.js.map